import React from 'react'
import TournamentMatch from './TournamentMatch'
import TournamentStandings from './TournamentStandings'
import TournamentGroups from './TournamentGroups'

const groupByRound = (matches) => {
  const rounds = new Map()
  for (const match of matches) {
    if (!rounds.has(match.round)) rounds.set(match.round, [])
    rounds.get(match.round).push(match)
  }
  return [...rounds.keys()]
    .sort((a, b) => a - b)
    .map((round) => ({ round, matches: rounds.get(round) }))
}

const KnockoutBracket = ({ matches, champion, editable, onSubmitResult }) => {
  const rounds = groupByRound(matches)
  return (
    <>
      {champion && (
        <p className="tournament-champion">
          <span role="img" aria-label="troféu">
            🏆
          </span>{' '}
          Campeão: {champion}
        </p>
      )}
      <div className="tournament-bracket">
        {rounds.map(({ round, matches: roundMatches }) => {
          const title = roundMatches.length === 1 ? 'Final' : `Rodada ${round}`
          return (
            <div className="tournament-round" key={round}>
              <h2 className="tournament-round-title">{title}</h2>
              {roundMatches.map((match) => (
                <TournamentMatch key={match.id} match={match} editable={editable} onSubmit={onSubmitResult} />
              ))}
            </div>
          )
        })}
      </div>
    </>
  )
}

const TournamentBoard = ({ state, editable, onSubmitResult }) => {
  if (!state.generated) return null

  if (state.format === 'league') {
    const rounds = groupByRound(state.matches)
    return (
      <>
        <TournamentStandings standings={state.standings} />
        {rounds.map(({ round, matches }) => (
          <div className="tournament-league-round" key={round}>
            <h2 className="tournament-matches-heading">Rodada {round}</h2>
            <div className="tournament-league-matches">
              {matches.map((match) => (
                <TournamentMatch key={match.id} match={match} editable={editable} onSubmit={onSubmitResult} />
              ))}
            </div>
          </div>
        ))}
      </>
    )
  }

  if (state.format === 'groups') {
    return (
      <>
        <TournamentGroups
          groups={state.groups}
          editable={editable && state.phase === 'groups'}
          onSubmitResult={onSubmitResult}
        />
        {state.phase === 'knockout' && (
          <>
            <h2 className="tournament-matches-heading">Mata-mata</h2>
            <KnockoutBracket
              matches={state.matches}
              champion={state.champion}
              editable={editable}
              onSubmitResult={onSubmitResult}
            />
          </>
        )}
      </>
    )
  }

  return (
    <KnockoutBracket
      matches={state.matches}
      champion={state.champion}
      editable={editable}
      onSubmitResult={onSubmitResult}
    />
  )
}

export default TournamentBoard
